import React, { useEffect, useState } from 'react';
import { Table, TableHeader } from '~/components/Table';
import Box from '~/components/Box';
import { Button, Col, Flex, Input, Modal } from 'antd';
import Pagination from '~/components/Pagination';
import Global from '~/styles/global';
import { getEmployees } from '~/services/hooks/employees';
import { ModalFooter } from '~/components/Modal';
import { SelectAntd } from '~/components/Pagination/styles';
import { getStates } from '~/services/hooks/states';
import { getCities } from '~/services/hooks/cities';
import { employeesImportColumns } from '~/tables/employees';
import errorHandler from '~/Utils/errorHandler';

export default function EmployeeModal({
  visible = false,
  t = () => {},
  onClose = () => {},
  values = null,
  setFieldValue = () => {},
  operationalId = null,
  sectorId = null,
  sectorIndex = null,
  sectorOperationalIndex = null,
  fluidPermissions = () => {},
  isMobile = false,
}) {
  const [employees, setEmployees] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});
  const [searchParams, setSearchParams] = useState({
    name: null,
    classification: '',
    departure_at: null,
    state_id: null,
    city_id: null,
  });
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState(null);

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          perPage,
          operationalId,
          active: true,
          inEvent: values?.team?.[0]?.departure_at,
          ...searchParams,
        },
      };
      const employees = await getEmployees(params);
      setEmployees(employees.data);
      setMeta(employees.meta);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const fetchStates = async () => {
    setLoading(true);
    try {
      const states = await getStates('', 'no-paginated');
      setStates(states);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const fetchCities = async () => {
    setLoading(true);
    try {
      const data = await getCities('', 'no-paginated');

      setCities(data);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleAddEmployee = (employeeId, employeeName, employeePhone) => {
    const newTeam = [
      ...values.team,
      {
        event_id: values?.id,
        employee_id: employeeId,
        employee_name: employeeName,
        employee_phone: employeePhone,
        operational_id: operationalId,
        sector_id: sectorId,
        sector_index: sectorIndex,
        sector_operational_index: sectorOperationalIndex,
        departure_time: null,
        extra: 0,
        departure_at: values?.default_departure_at,
      },
    ];

    setFieldValue('team', newTeam);
    onClose();
  };

  useEffect(() => {
    if (visible) {
      fetchEmployees();
    }
  }, [visible, page, perPage, searchParams]);

  useEffect(() => {
    if (visible) {
      fetchStates();
      fetchCities();
    }
  }, [visible]);

  return (
    <Modal
      title={t('Selecionar colaborador')}
      onCancel={onClose}
      style={{ maxWidth: isMobile ? '100%' : '1000px' }}
      afterClose={() => {
        setEmployees([]);
        setPage(1);
        setPerPage(10);
        setSearchParams({
          name: '',
          classification: '',
          departure_at: null,
          cities: null,
          city_id: null,
        });
        setSelectedState(null);
        setCities([]);
        setStates([]);
      }}
      open={visible}
      centered
      width={isMobile ? '100%' : '1000px'}
      footer={<ModalFooter loading={loading} onCancel={onClose} />}
    >
      <Box>
        <TableHeader>
          <Flex vertical align="center" justify="center" gap={10} style={{ width: '100%' }}>
            <Col
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                flexWrap: 'wrap',
              }}
            >
              <Input.Search
                placeholder="Pesquisar"
                onSearch={(value) => setSearchParams((thisValues) => ({ ...thisValues, name: value }))}
                style={{ width: isMobile ? '100%' : 300 }}
              />
              <SelectAntd
                placeholder="Classificação"
                onSelect={(value) => {
                  setSearchParams((thisValues) => ({ ...thisValues, classification: value }));
                }}
                loading={loading}
                style={{ width: isMobile ? '48%' : 150, marginTop: isMobile ? 10 : '' }}
                disabled={!fluidPermissions()}
              >
                <SelectAntd.Option key={0} value={0}>
                  A
                </SelectAntd.Option>
                <SelectAntd.Option key={1} value={1}>
                  B
                </SelectAntd.Option>
                <SelectAntd.Option key={2} value={2}>
                  C
                </SelectAntd.Option>
              </SelectAntd>
              <SelectAntd
                placeholder="Trabalhou no últimos 30 dias"
                value={searchParams.departure_at ?? null}
                onSelect={(value) => {
                  setSearchParams((thisValues) => ({ ...thisValues, departure_at: value }));
                }}
                loading={loading}
                style={{ width: isMobile ? '48%' : 230, marginTop: isMobile ? 10 : '' }}
                disabled={!fluidPermissions()}
              >
                <SelectAntd.Option key={1} value={1}>
                  1
                </SelectAntd.Option>
                <SelectAntd.Option key={2} value={2}>
                  2
                </SelectAntd.Option>
                <SelectAntd.Option key={3} value={3}>
                  3
                </SelectAntd.Option>
                <SelectAntd.Option key={4} value={4}>
                  4
                </SelectAntd.Option>
                <SelectAntd.Option key={5} value={5}>
                  5
                </SelectAntd.Option>
                <SelectAntd.Option key={6} value={6}>
                  6
                </SelectAntd.Option>
                <SelectAntd.Option key={7} value={7}>
                  7
                </SelectAntd.Option>
                <SelectAntd.Option key={8} value={8}>
                  8
                </SelectAntd.Option>
                <SelectAntd.Option key={9} value={9}>
                  9
                </SelectAntd.Option>
                <SelectAntd.Option key={10} value={10}>
                  10
                </SelectAntd.Option>
              </SelectAntd>
            </Col>
            <Col
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                flexWrap: 'wrap',
              }}
            >
              <SelectAntd
                placeholder="Estado"
                onSelect={(value) => {
                  setSearchParams((thisValues) => ({ ...thisValues, state_id: value }));
                  setSelectedState(value);
                }}
                value={selectedState ?? null}
                showSearch
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                loading={loading}
                style={{ width: isMobile ? '48%' : 150, marginTop: isMobile ? 10 : '' }}
                disabled={!fluidPermissions()}
              >
                {states?.map((state) => (
                  <SelectAntd.Option key={state.id} value={state.id}>
                    {state.name}
                  </SelectAntd.Option>
                ))}
              </SelectAntd>
              <SelectAntd
                placeholder="Cidade"
                value={searchParams?.city_id ?? null}
                onSelect={(value) => {
                  setSearchParams((thisValues) => ({ ...thisValues, city_id: value }));
                }}
                showSearch
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                loading={loading}
                style={{ width: isMobile ? '48%' : 150, marginTop: isMobile ? 10 : '' }}
                disabled={!selectedState || !fluidPermissions()}
              >
                {cities
                  ?.filter((c) => c?.state_id === selectedState)
                  ?.map((c) => (
                    <SelectAntd.Option key={c.id} value={c.id}>
                      {c.name}
                    </SelectAntd.Option>
                  ))}
              </SelectAntd>
              <Button
                title="Limpar pesquisa"
                onClick={() => {
                  setSelectedState(null);
                  setSearchParams((thisValues) => ({
                    ...thisValues,
                    city_id: null,
                    state_id: null,
                    departure_at: null,
                    classification: '',
                  }));
                }}
                disabled={!fluidPermissions()}
                style={{ marginTop: isMobile ? 10 : '' }}
              >
                {t('Limpar')}
              </Button>
            </Col>
          </Flex>
        </TableHeader>
        <Table
          pagination={false}
          rowKey="id"
          loading={loading}
          dataSource={employees}
          columns={employeesImportColumns(
            handleAddEmployee,
            isMobile,
            values?.team?.map((team) => team.employee_id)
          )}
          size="small"
          bordered
          onRow={(record) => ({
            style: {
              backgroundColor: record.in_event ? '#FFEAEA' : undefined,
            },
          })}
        />
        <Pagination
          isMobile={isMobile}
          onChange={(value) => {
            setPage(value);
          }}
          meta={meta}
          perPage={perPage}
          setPerPage={setPerPage}
        />
        <Global />
      </Box>
    </Modal>
  );
}
